import { Component, computed, inject, signal } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { AppHeader } from './components/app-header/app-header';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AppHeader],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  private router = inject(Router);

  protected readonly title = signal('flippy-board-web');

  // Track current URL to detect demo route
  private currentUrl = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event) => event.urlAfterRedirects),
    ),
    { initialValue: this.router.url },
  );

  // Check if we're on a route that should hide the header (demo or display)
  protected readonly isDisplayRoute = computed(() => {
    const url = this.currentUrl();
    return (
      url?.startsWith('/boards/') ||
      url?.startsWith('/demo') ||
      url?.startsWith('/display/') ||
      false
    );
  });
}
